import {Component, Input, OnDestroy, inject, OnInit} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {DataViewModule} from "primeng/dataview";
import {MenuModule} from "primeng/menu";
import {OrderListModule} from "primeng/orderlist";
import {SharedModule} from "primeng/api";
import {SkeletonModule} from "primeng/skeleton";
import {SplitButtonModule} from "primeng/splitbutton";
import {TooltipModule} from "primeng/tooltip";
import {
    DataService
} from "../../../service/data.service";
import {PlatformRole, ProjectDescriptorUse} from 'src/app/api/enums';
import {Subscription} from "rxjs";
import {DividerModule} from "primeng/divider";
import {ProjectDescriptorPanelComponent} from "../../project-descriptor/project-descriptor-panel.component";
import {PlatformUser} from "../../../api/db/entities/PlatformUser";
import {BetaReaderProfile} from "../../../api/db/entities/BetaReaderProfile";
import {ProjectProfileGroup} from "../../../api/db/entities/ProjectProfileGroup";
import {ProjectSchemaDisplay, ProjectSchemas} from "../../../api/project_schemas";
import {Tab, TabList, TabPanel, TabPanels, Tabs} from "primeng/tabs";
import { ProgressService } from 'src/app/service/progress.service';

@Component({
    selector: 'beta-reader-reading-profile',
    imports: [
        ButtonModule,
        ConfirmDialogModule,
        DataViewModule,
        MenuModule,
        OrderListModule,
        SharedModule,
        SkeletonModule,
        SplitButtonModule,
        TooltipModule,
        DividerModule,
        ProjectDescriptorPanelComponent,
        Tabs,
        TabList,
        TabPanels,
        TabPanel,
        Tab
    ],
    standalone: true,
    templateUrl: './beta-reader-reading-profile.component.html',
    styleUrl: './beta-reader-reading-profile.component.scss'
})

export class BetaReaderReadingProfileComponent implements OnInit {
    protected dataService = inject(DataService);
    private progressService = inject(ProgressService);


    @Input() betaReader!: BetaReaderProfile;
    @Input() platformUser: PlatformUser;

    protected currentSelectedSchemaCode: string = ProjectSchemas.DEFAULT_PROJECT_SCHEMA_DISPLAY.code;
    protected profileGroup: ProjectProfileGroup;

    protected testArray: string[] = ["FICTION_SERIES"];

    constructor() {
    }

    ngOnInit(): void {
        if (!this.platformUser.roles.includes(PlatformRole.BETAREADER.valueOf())) {
            console.log('NOT AUTHORIZED TO VIEW PAGE>>>>>BETA READER');
            this.dataService.redirectToHome();
        }
        //originally used ProjectSchemas.CODES, but that returns an empty array right now
        for (const code of this.testArray) {
            if (!this.betaReader.getProfileGroupForCode(code)) {
                const pg = new ProjectProfileGroup();
                pg.projectSchemaCode = code;
                this.betaReader.profileGroups.push(pg);
                console.log("I pushed a new ProjectProfile object");
            }
        }
        console.log("ALSKHLDHGKFJSGHKJSDHFJKLSHDF");
        this.profileGroup = this.betaReader.getProfileGroupForCode(this.currentSelectedSchemaCode);
        if (!this.profileGroup.profileSelections) {
            //this.profileGroup.profileSelections = [];
        }
        console.log("Here is the profile group: ", this.profileGroup);
        console.log(this.profileGroup.profileSelections);
        console.log(this.platformUser);
        console.log("HERE IS STORED USER!!!: ", this.dataService.debugPlatformUser());
        /*console.log(this.currentSelectedSchemaCode);
        console.log(this.ProjectSchemas.CODES);
        console.log(this.ProjectSchemas);
        console.log(this.ProjectSchemas.SCHEMADISPLAY_BY_CODE);*/
    }

    async save() {
        //console.log(this.values);
      
            
        
        console.log(this.betaReader);
            //this.progressService.blockWithMessage("Saving Selections");
        await this.dataService.saveBetaReader(this.betaReader);

        await this.dataService.saveReaderProfileGroup(this.betaReader, this.profileGroup);


        await this.dataService.matchProjectToReader(this.profileGroup);
    
        
        //this.progressService.unBlock;
    }

    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;
    protected readonly ProjectSchemas = ProjectSchemas;
}
